<template>
    <div :class="containerStyleClass">
        <input
            :name="inputName"
            :class="inputStyleClass"
            :id="inputId"
            :value="modelValue"
            @input="updateValue"
            :type="inputType"
            :placeholder="t(placeholder, placeholderParams)"
            :disabled="isDisabled"
            :data-cy="cypressData"
            :autocomplete="autocompleteValue"
        />
        <label :for="inputName" :class="labelStyleClass">{{ t(label) }}</label>
    </div>
</template>

<script lang="ts" setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();

defineProps<{
    containerStyleClass?: string;
    inputStyleClass?: string;
    labelStyleClass?: string;
    placeholder?: string;
    placeholderParams?: any;
    modelValue?: string;
    isDisabled?: boolean;
    inputId?: string;
    label?: string;
    inputName?: string;
    cypressData?: string;
    autocompleteValue?: string;
    inputType?: string;
}>();

const emit = defineEmits(["update:modelValue"]);
const updateValue = (event: any) => {
    emit("update:modelValue", event.target.value);
};
</script>
